import {KeypadView, KeypadViewMobile} from '@gongxigames/framework/slot/modules/keypad';
import {Module} from '@gongxigames/framework/slot/fragments/module/Module';

// TODO: refactoring required
// @ts-ignore
export class KeypadModule extends Module<KeypadView|KeypadViewMobile> {
    public static readonly NAME: symbol = Symbol('KeypadModule');

    protected setupViews(): void {
        if (this.isPlatformDesktop()) {
            this.setView(KeypadView.NAME);
        } else {
            this.setView(KeypadViewMobile.NAME);
        }
    }

    protected setupStates(): void {
    }
}
